// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"212":"3b8a018fa7a70c8b","613":"69e5df58f41c15c7"}[chunkId] + ".js";
};